import { useTranslation } from 'react-i18next';
import { useMe } from '../lib/auth';

/**
 * Shown until the family records its first transaction: after that the base currency is locked
 * (owner request, Phase 2).
 */
export function CurrencyLockNotice() {
  const { t } = useTranslation();
  const me = useMe();
  if (!me.data || me.data.family.currencyLocked) return null;
  return (
    <p role="note" className="rounded-xl border border-line bg-surface-2 p-3 text-sm text-fg">
      {t('currency.lockWarning', { currency: me.data.family.baseCurrency })}
    </p>
  );
}
